const API_BASE = import.meta.env.VITE_API_URL ?? "";

export type KitStatus = "ready" | "processing";

export interface Kit {
  order_name: string;
  status: KitStatus;
  token: string | null;
  created_at: string | null;
  items: string[];
}

/**
 * Fetch the signed-in customer's kits.
 * Returns `null` when there is no valid session (the page shows sign-in).
 * Throws on any other (unexpected) error.
 */
export async function getKits(): Promise<Kit[] | null> {
  const res = await fetch(`${API_BASE}/api/kits`, { credentials: "include" });
  if (res.status === 401) return null;
  if (!res.ok) throw new Error(`API ${res.status}: ${await res.text()}`);
  return res.json();
}

/**
 * Full-page navigation to the logout endpoint, which clears our session and
 * bounces through Shopify's OIDC logout (ending the Shopify session) before
 * returning to /kit. Must be a navigation, not a fetch.
 */
export function logout(): void {
  window.location.href = `${API_BASE}/api/auth/shopify/logout`;
}
